export default {"src":"/_next/static/media/x-close (1).c9250137.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};